import { render } from "./LeaveStatusForm.vue?vue&type=template&id=70dda1a6&scoped=true"
import script from "./LeaveStatusForm.vue?vue&type=script&lang=js"
export * from "./LeaveStatusForm.vue?vue&type=script&lang=js"

import "./LeaveStatusForm.vue?vue&type=style&index=0&id=70dda1a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dda1a6"]])

export default __exports__